import { Dispatch } from '@reduxjs/toolkit'
import { Product } from 'application/core/domain/entity/product/Product'
import { removeProduct, removeProducts } from 'application/core/domain/store/basketReducer'

export const removeProductFromBasket = (product: Product) => (dispatch: Dispatch) =>
  removeProduct(product)(dispatch)

export const removeProductsFromBasket = (uniq_ids: Array<string>) => (dispatch: Dispatch) =>
  removeProducts(uniq_ids)(dispatch)
